export const UPDATE_SCREEN_INFO = 'UPDATE_SCREEN_INFO';
export interface UpdateScreenInfoAction {
  type: typeof UPDATE_SCREEN_INFO;
  payload: {
    name?: string | null;
    date?: string | null;
    location?: string | null;
    description?: string | null;
  };
}
export const updateScreenInfo = (
  payload: UpdateScreenInfoAction['payload'],
): UpdateScreenInfoAction => ({
  type: UPDATE_SCREEN_INFO,
  payload,
});

export const UPDATE_SCREEN_NAME = 'UPDATE_SCREEN_NAME';
export interface UpdateScreenNameAction {
  type: typeof UPDATE_SCREEN_NAME;
  payload: {
    name: string;
  };
}
export const updateScreenName = (
  payload: UpdateScreenNameAction['payload'],
): UpdateScreenNameAction => ({
  type: UPDATE_SCREEN_NAME,
  payload,
});

export const UPDATE_SCREEN_DATE = 'UPDATE_SCREEN_DATE';
export interface UpdateScreenDateAction {
  type: typeof UPDATE_SCREEN_DATE;
  payload: {
    date: string;
  };
}
export const updateScreenDate = (
  payload: UpdateScreenDateAction['payload'],
): UpdateScreenDateAction => ({
  type: UPDATE_SCREEN_DATE,
  payload,
});

export const UPDATE_SCREEN_LOCATION = 'UPDATE_SCREEN_LOCATION';
export interface UpdateScreenLocationAction {
  type: typeof UPDATE_SCREEN_LOCATION;
  payload: {
    location: string;
  };
}
export const updateScreenLocation = (
  payload: UpdateScreenLocationAction['payload'],
): UpdateScreenLocationAction => ({
  type: UPDATE_SCREEN_LOCATION,
  payload,
});

export const UPDATE_SCREEN_DESCRIPTION = 'UPDATE_SCREEN_DESCRIPTION';
export interface UpdateScreenDescriptionAction {
  type: typeof UPDATE_SCREEN_DESCRIPTION;
  payload: {
    description: string;
  };
}
export const updateScreenDescription = (
  payload: UpdateScreenDescriptionAction['payload'],
): UpdateScreenDescriptionAction => ({
  type: UPDATE_SCREEN_DESCRIPTION,
  payload,
});

export type ActionType =
  | UpdateScreenInfoAction
  | UpdateScreenNameAction
  | UpdateScreenDateAction
  | UpdateScreenLocationAction
  | UpdateScreenDescriptionAction;
